export const wrapInner = (
  parentEl: Element,
  wrapper: string,
  attribute?: string,
  attributeValue?: string
) => {
  const wrapperEl = document.createElement(wrapper)

  parentEl.appendChild(wrapperEl)

  if (attribute && attributeValue) {
    wrapperEl.setAttribute(attribute, attributeValue)
  }

  while (parentEl.firstChild !== null && parentEl.firstChild !== wrapperEl) {
    wrapperEl.appendChild(parentEl.firstChild)
  }

  return wrapperEl
}

export const getOffset = (el: Element) => {
  const { top, left } = el.getBoundingClientRect()
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop

  return { top: top + scrollTop, left: left + scrollLeft }
}
